export const oneLevelUp = nLevelsUp(1);

export function nLevelsUp(n) {
  return function moveNLevelsUp(location) {
    var parts = location.pathname.split("/");
    return parts.slice(0, parts.length - n).join("/");
  };
}
